import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import injectSaga from 'utils/injectSaga';
import withStyles from 'utils/withStyles';

import CapLanguageProvider from '@capillarytech/cap-ui-library/CapLanguageProvider';

import sagas from './saga';
import * as globalSelectors from '../Cap/selectors';
import styles from './style';
import * as Api from '../../../services/api';
const { makeSelectUser } = globalSelectors;

export class LanguageProvider extends React.PureComponent {
  constructor() {
    super();
  }

  // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <CapLanguageProvider
        user={this.props.user}
        supportedLocalesDetails={this.props.supportedLocalesDetails}
        locizeApi={Api.getLocizeMessage}
        supportedLocalesApi={Api.getSupportedLocales}
        className={this.props.className}
      >
        {React.Children.only(this.props.children)}
      </CapLanguageProvider>
    );
  }
}

LanguageProvider.propTypes = {
  language: PropTypes.object,
  supportedLocalesDetails: PropTypes.object,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
  actions: PropTypes.object,
  user: PropTypes.object,
  className: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

const withConnect = connect(mapStateToProps);

const withSagas = sagas.map(saga => injectSaga(saga));

export default compose(
  ...withSagas,
  withConnect,
)(withStyles(LanguageProvider, styles));
